import type { EntityAction } from "@firecms/core";
import { SwapHorizIcon } from "@firecms/ui";
import type { AssignedParticipant } from "../../collections/participants";
import { getAdminT } from "../../i18n/getAdminT";
import { getAdminUiLocale } from "../../i18n/getAdminUiLocale";
import { tableOnlyEntityAction } from "../entityActionDefaults";
import { openChangeTeamDialog } from "./changeSlotTeamBridge";

export function buildChangeParticipantTeamEntityAction(): EntityAction<AssignedParticipant> {
  const t = getAdminT(getAdminUiLocale());

  return {
    key: "change-participant-team",
    name: t("changeTeam.entityAction"),
    icon: <SwapHorizIcon />,
    ...tableOnlyEntityAction,
    collapsed: false,
    onClick: async ({ entity }) => {
      if (!entity) {
        return;
      }
      // participant doc id = Auth uid
      openChangeTeamDialog(entity.id);
    },
  };
}
